import React, { useEffect, useState } from 'react';
import './FullLeaderboard.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { useContext } from 'react';
import { PageNavContext } from '../../../FunctionalPageLogin';

const apiUrl = process.env.REACT_APP_API_URL;

export default function FullLeaderboard() {
  const pageNav = useContext(PageNavContext);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadLeaderboard = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/leaderboard?type=weekly`,
          {
            credentials: 'include',
          }
        );

        if (!response.ok) {
          throw new Error('Nu am putut incarca clasamentul.');
        }

        const data = await response.json();

        if (!isMounted) {
          return;
        }

        setUsers(
          Array.isArray(data)
            ? data
            : []
        );

        setError('');
      } catch (err) {
        if (!isMounted) {
          return;
        }

        console.error(err);

        setError(
          'Clasamentul nu poate fi afisat momentan.'
        );
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadLeaderboard();

    return () => {
      isMounted = false;
    };
  }, []);

  const visibleUsers = users.filter(
    (user) =>
      (Number(user?.points) || 0) > 0
  );

  return (
    <div className="full-leaderboard-page">

      <div className="full-leaderboard-header">

        <button
          type="button"
          className="full-leaderboard-back"
          onClick={() => pageNav('Clasament')}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

        <div>
          <h1>
            Clasamentul complet
          </h1>

          <p>
            Vezi toti utilizatorii activi din aceasta saptamana.
          </p>
        </div>

      </div>

      <div className="full-leaderboard-list">

        {loading && (
          <div className="full-leaderboard-message">
            Se incarca clasamentul...
          </div>
        )}

        {!loading && error && (
          <div className="full-leaderboard-message">
            {error}
          </div>
        )}

        {!loading &&
          !error &&
          visibleUsers.map((user, index) => {

            const rank =
              Number(user.position) ||
              index + 1;

            return (
              <div
                key={
                  user.user_id ||
                  `${user.username}-${index}`
                }
                className={[
  'full-leaderboard-row',
  rank === 1 ? 'full-leaderboard-row-first' : '',
  rank === 2 ? 'full-leaderboard-row-second' : '',
  rank === 3 ? 'full-leaderboard-row-third' : '',
]
  .filter(Boolean)
  .join(' ')}
              >

                <div className="full-leaderboard-rank">
                  #{rank}
                </div>

                <div className="full-leaderboard-avatar">

                  {user.profile_picture ? (
                    <img
                      src={user.profile_picture}
                      alt={user.username || 'Utilizator'}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faUser}
                    />
                  )}

                </div>

                <div className="full-leaderboard-name">
                  {user.username || 'Utilizator'}
                </div>

                <div className="full-leaderboard-xp">
                  {Number(user.points) || 0} XP
                </div>

              </div>
            );

          })}

      </div>

    </div>
  );
}